import React, { useEffect, useState, lazy, useMemo } from "react";
import { useHistory , useLocation} from "react-router-dom";
import Header from "./../home/Header";
import { BookingProvider } from "./../home/bookingContext";
import BookingFor from "./../home/Bookingfor";
// import BookingConfirmationPrice from "./../../../components/bookingConfirmation/BookingConfirmationPrice";
import BookingItineryDetails from '../../../components/bookings/BookingItinerary ';
import BookingItinenaryMulticity from '../../../components/bookings/BookingItineraryMulticity';
import BookingItineraryOneway from '../../../components/bookings/BookingItineraryOneway';
import { useDispatch, useSelector, useStore } from "react-redux";
import { CONFIG, TripType, taxIncreasedStatusArray } from "../../../utils/constant"
import { getPnrDetails } from "../../../appStore/thunks/getPnrDetails";
import { setBookingItinenary } from "../../../appStore/actionCreators/searchForm"
import { updatePnr } from "../../../appStore/thunks/updatePnr";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import { setSeat, setPrevSeat, setEditSeat, setSeatMapData, setSaveSeat, setEditSeatRecord, setIsPassportMandatory } from "../../../appStore/actionCreators/itinenary"
import { setBookingDetails, setMarkupApplied,setItinaryFaresType, setPnr, setUpdatePnrCalculatorFlow, setPaymentRules, setPaymentRulesForCheque, setItenaryData, setInitialPaymentRules, setInitialPaymentRulesChq, setPaymentRulesForNonAcceptedCC, setMerchantFeeForNonAcceptedCC, setPaymentErrorMsg } from "../../../appStore/actionCreators/flightBooking"
import { getPaymentRules } from "../../../appStore/thunks/getPaymentRules";
import { PassengerType } from "../../../../src/utils/constant";
import moment from "moment";
import queryString from 'query-string'
import { ssoAuthetication } from "../../../appStore/thunks/ssoAuthetication";
import SpinnerLoader from "./../../../components/common/spinner"
import ConfirmationHead from "./../../../components/bookingConfirmation/ConfirmationHead";
import BookingQuoteNote from "./../../../components/bookingConfirmation/BookingQuoteNote"
import Markup from "../../../components/bookings/Markup"
import BookingNumberForLandCruise from "../../../components/bookings/BookingNumberForLandCruise";
// import BookingItineryDetails from '../../../components/bookings/BookingItinerary ';
// import BookingItinenaryMulticity from '../../../components/bookings/BookingItineraryMulticity';
// import BookingItineraryOneway from '../../../components/bookings/BookingItineraryOneway';
import { useTranslation } from "react-i18next";
import { dobAgeCheckValidation,flightCarriersDataPassportMandatory } from "../../../utils/utility/commenFunctions";
import {
  buildSeatPnrOperationsFromDelta,
  hasSeatSelectionChanges,
} from '../../../integrations/seatMap/seatMapMappers';
import { getRepriceBeforePayment } from "../../../appStore/thunks/getRepriceBeforePayment"; 
import { Dialog } from "@material-ui/core";
import infoIcon from '../../../Assets/infoIcon.png'
import { setAgentToken, setOrgId } from "../../../appStore/actionCreators/agent";
// import BookingConfirmationButton from "./../../../components/bookingConfirmation/BookingConfirmationButton";
// import BookingConfirmationPrice from "./../../../components/bookingConfirmation/BookingConfirmationPrice";
// import BookingPassengerDetails from "./../../../components/bookingConfirmation/BookingPassengerDetails";
// import BookingPaymentSummary from '../../../components/bookings/BookingPaymentSummary';
// import BookingTravelAgentInfo from "../../../components/bookings/BookingTravelAgentInfo";

const BookingConfirmationPrice = lazy(() => import('./../../../components/bookingConfirmation/BookingConfirmationPrice'))
const BookingPassengerDetails = lazy(() => import('./../../../components/bookingConfirmation/BookingPassengerDetails') )
const BookingConfirmationButton = lazy(() => import('./../../../components/bookingConfirmation/BookingConfirmationButton'))
const BookingPaymentSummary = lazy(() => import('../../../components/bookings/BookingPaymentSummary'))
const BookingTravelAgentInfo = lazy(() => import('../../../components/bookings/BookingTravelAgentInfo'))
const DuffelPriceSummary = lazy(() => import('./../../../components/bookings/DuffelPriceSummary'))

toast.configure();

function BookingConfirmationContainer() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const store = useStore();
  const location = useLocation();
  let bookingItinenaries = useSelector(
    (state) => state.searchForm.bookingItinenary
  );
  const priceValue = useSelector(
    (state) => state.flightBooking.bookingItenaries
  );
  const tripTypeValue = useSelector((state) => state.searchForm.tripType);
  const flightDetail = useSelector((state) => state.flightBooking);
  const bookingData = useSelector((state) => state.flightBooking.bookingDetails);
  const bookingDate = useSelector((state) => state.flightBooking.bookingDate);  
  const seat = useSelector((state) => state.itinenaries.seat);
  const paxFares =
    bookingData &&
    bookingData.itineraryFare &&
    bookingData.itineraryFare.paxFares;
  const paymentTypeDetails =
    bookingData && bookingData.payments ? bookingData.payments : [];
  const bookingStatus = useSelector(
    (state) => state.flightBooking.bookingStatus
  );
  const tripTypeFlowFrom = useSelector((state) => (state.flightBooking.tripTypeFlowFrom));
  const updatePnrCalculatorFlow = useSelector((state) => (state.flightBooking.updatePnrCalculatorFlow));
  const allData = useSelector((state) => (state.flightBooking.getPnrResult));
  const tripData = useSelector((state) => state.searchForm.tripData);
  const providerId = useSelector((state) => state.searchForm.providerId);
  const isPassportMandatory = useSelector((state) => state.itinenaries.isPassport);
  const pnrBookingDetails = useSelector(
    (state) => state.flightBooking.pnrCancellationStatus
  );
  const saveCalculatorFlow = useSelector((state)=> state.flightBooking.saveCalculatorFlow);
  let isDuffleFlow = useSelector((state)=> state.itinenaries.providerType);
  let provider = useSelector((state) => state.flightBooking.providerName);
  const paymentErrorMsg = useSelector((state) => state.flightBooking.paymentErrorMsg);
  const [paymentErrorBanner, setPaymentErrorBanner] = useState("");
  const configuration = useMemo(() => CONFIG[provider], [provider]);
  const [isload, setLoad] = useState(false);
  const [editPassenger, setEditPassenger] = useState([]);
  const [addPassenger, setAddPassenger] = useState([]);
  const [prevState, setAddedSeatList] = useState([]);
  const [editSeatStatus, setEditSeatStatus] = useState(false);
  const [isUpdate, setIsUpdate] = useState("");
  const [updateOperations1, setUpdateOperations1] = useState("");
  const [ticketableDateCheck, setTicketableDateCheck] = useState(false);
  const [expandedPaymentDetails,setExpandedPaymentDetails]= useState([]);
  const [validInfo, setValidInfo] =  useState(false);
  const [getBookingErrorMsg, setGetBookingErrorMsg] = useState(false);
  const [nonGigiPNRCheck,setNonGigiPNRCheck] = useState(false);
  const [saveDetails, setSaveDetails]= useState(false);
  const [timeOutError, setTimeoutError] = useState(false);
  const [isPQupdatedManually, setIsPQupdatedManually] = useState(false)
  const [isPaymentDoneManually, setIsPaymentDoneManually] = useState(false)
  const [dobGenderError, setDobGenderError] = useState(false)
  const [verifyPnrPopUp, setVerifyPnrPopUp] = useState(false)
  const [fetchLatestFare, setFetchLatestFare] = useState(false)
  const [isItineraryModified, setIsItineraryModified] = useState(false)
  const [itineraryFareNotPresent, setIitineraryFareNotPresent] = useState(false)
  const [counter,setCounter]=useState(0)
  // const [isVerifyPNRFailed, setIsVerifyPNRFailed] = useState(false);
  const agencyDetails = useSelector(
    (state) => state.agentProfile.agencyDetails
  );
  const recordLocator = useSelector((state) => state.flightBooking.pnr);
  const [localRecordLocator, setLocalRecordLocator] = useState(recordLocator);
  const orgId = useSelector((state) => state.agentProfile.orgId);
  const agencyId = useSelector((state) => state.agentProfile.agencyId);
  const agencyGroupId = useSelector(
    (state) => state.agentProfile.agencyGroupId
  );
  const agentDetails = useSelector((state) => state.agentProfile.agentDetails);
  const isInternalUserAutheticated = useSelector((state) => state.internalUser.isInternalUserAutheticated);
  const agentEmergencyNumber = useSelector((state) => state.flightBooking.agentEmergencyNumber);
  const agentOldUserId=useSelector((state) => state.agentProfile.agentOldUserId);
  const emailLanguage = useSelector((state) => state.flightBooking.emailLanguage);
  // const isVerifyPNRFailed = useSelector((state) => state.flightBooking.isVerifyPNRFailed);
  const optionDateToDisplay = bookingData && bookingData.itineraryFare && bookingData.itineraryFare.lastTicketableDateToDisplay;
  let requireInstantPurchase = bookingData && bookingData.itineraryFare && bookingData.itineraryFare.requireInstantPayment;
  const passengerData = bookingData?.passengers
  const segment = bookingData?.segments
  let agencyMarkups = bookingData && bookingData.agencyMarkups
  let fareTypeFromPnr = bookingData && bookingData.itineraryFare && bookingData.itineraryFare.type;
  let adultAmount;
  let childAmount;
  let infantAmount;
  let pnrBookingStatus  = pnrBookingDetails?.bookingStatusDetail?.code;
  let productionEnvFlag = false;
  let cancellationFlag = true;
  if(pnrBookingStatus === "PT" && productionEnvFlag){
    cancellationFlag = false;
  }
  const convertedBookingDate = bookingDate && moment.tz(bookingDate, "America/Chicago").tz("America/New_York");
  const currentTimeET = moment.tz("America/New_York");
  const isWithin15Minutes = convertedBookingDate
    ? currentTimeET.diff(convertedBookingDate, "minutes") < 15
    : false;
  const showTicketProcessingNote = provider !== "Sabre" && isWithin15Minutes;
  // console.log("showTicketProcessingNote", {showTicketProcessingNote,provider,bookingDateRaw: bookingDate,convertedBookingDateET: convertedBookingDate? convertedBookingDate.format("YYYY-MM-DD HH:mm:ss z"): null,currentTimeET: currentTimeET.format("YYYY-MM-DD HH:mm:ss z"),diffMinutes: convertedBookingDate? currentTimeET.diff(convertedBookingDate, "minutes"): null,isWithin15Minutes,});
  
  if (agencyMarkups && agencyMarkups.length > 0) {
    let adultData = agencyMarkups.filter(
      (obj) => obj.paxType === PassengerType.ADULT
    );
    let childData = agencyMarkups.filter(
      (obj) => obj.paxType === PassengerType.CHILD
    );
    let infantdata = agencyMarkups.filter(
      (obj) => obj.paxType === PassengerType.INFANTINLAP
    );
    adultAmount =
      adultData && adultData[0]
        ? adultData[0].perPaxAmount && adultData[0].perPaxAmount.amount
        : "";
    childAmount =
      childData && childData[0]
        ? childData[0].perPaxAmount && childData[0].perPaxAmount.amount
        : "";
    infantAmount =
      infantdata && infantdata[0]
        ? infantdata[0].perPaxAmount && infantdata[0].perPaxAmount.amount
        : "";
  }

  useEffect(()=>{
    if(paymentTypeDetails){
      let newPaymentTypeDetails=[];
      
      for(let i=0;i<paymentTypeDetails.length;i++){
        if(paymentTypeDetails[i].appliedTransactions){
          if(paymentTypeDetails[i].appliedTransactions.length >1){
            for(let j=0;j<paymentTypeDetails[i].appliedTransactions.length;j++){
              let arr={};
              if(paymentTypeDetails[i].cheque){
                arr={
                  type:paymentTypeDetails[i].type,
                  cheque:paymentTypeDetails[i].cheque,
                  appliedTransactions:[paymentTypeDetails[i].appliedTransactions[j]],
                  id:paymentTypeDetails[i].appliedTransactions[j].passengerRefId
                }
                newPaymentTypeDetails.push(arr)
                
                
              }else if(paymentTypeDetails[i].creditCard){
                arr={
                  type:paymentTypeDetails[i].type,
                  creditCard:paymentTypeDetails[i].creditCard,
                  appliedTransactions:[paymentTypeDetails[i].appliedTransactions[j]],
                  id:paymentTypeDetails[i].appliedTransactions[j].passengerRefId
                }
                newPaymentTypeDetails.push(arr)
                
              }
            }
          }else{
            let arr={};
            arr={
              id:paymentTypeDetails[i].appliedTransactions[0].passengerRefId,
              ...paymentTypeDetails[i]
            }
            newPaymentTypeDetails.push(arr)
          }
        }
      }
      let sort=newPaymentTypeDetails.sort((a,b)=>a.id-b.id);
      setExpandedPaymentDetails(sort);
      console.log("newPaymentTypeDetails",sort)
    }
  },[bookingData.payments])
    
  useEffect(() => {
    if ((!isload) && recordLocator !== localRecordLocator) {
      setLoads(true);
    }
  }, [recordLocator, localRecordLocator,isload])
  

  const currency =
    priceValue && priceValue.baseAmount && priceValue.baseAmount.currency;
  const adultsCount = useSelector((state) => state.flightBooking.pnrAdultCount);
  const childCount = useSelector((state) => state.flightBooking.pnrChildCount);
  const infantCount = useSelector(
    (state) => state.flightBooking.pnrInfantCount
  );
  const bookingWithQuote = useSelector(
    (state) => state.savedQuotes.bookingWithQuote
  );
  const editSeatRecord = useSelector(
    (state) => state.itinenaries.editSeatRecord
  );
  const bookingDetail = useSelector(
    (state) => state.flightBooking.bookingItenaries
  );
  let history = useHistory();

  const carrier = useSelector(
    (state) =>
      state.flightBooking &&
      state.flightBooking.bookingItenaries &&
      state.flightBooking.bookingItenaries.platingCarrierDetails &&
      state.flightBooking.bookingItenaries.platingCarrierDetails.carrier
  );

  useEffect(() => {
    dispatch(setMarkupApplied(true));
    dispatch(setItinaryFaresType(""));

  }, []);

  useEffect(() => {
    const currentDateTime = new Date();
    let resultDate = moment(currentDateTime).tz("America/Toronto").format();

    if(requireInstantPurchase){
      setTicketableDateCheck(false);
    }
    else if (optionDateToDisplay > resultDate) {
      setTicketableDateCheck(true);
    } else {
      setTicketableDateCheck(false);
    }
  }, [optionDateToDisplay, requireInstantPurchase]);

  // SSO TOKEN FLOW ON CONFIRMATION PAGE
  const valueFromUrl = queryString.parse(location && location.search);
  let ssoToken = valueFromUrl && valueFromUrl.token;
  let pnrFromUrl = valueFromUrl && valueFromUrl.pnr;
  let providerIdFromUrl = valueFromUrl && valueFromUrl.provider_id;
  let orgIdFromUrl = valueFromUrl && valueFromUrl.org_id;
  let lang = valueFromUrl && valueFromUrl?.lang?.toLowerCase();
  


  useEffect(()=>{
    ssoAuth()
  },[ssoToken])

  const ssoAuth = async() => {
    if(ssoToken){
      
      let ssoResult = await dispatch(ssoAuthetication(orgIdFromUrl,ssoToken,lang)) 
        if(ssoResult && ssoResult.hasOwnProperty("travelBusinessesId")){
        let agencyDetails = ssoResult
        dispatch(setPnr(pnrFromUrl))
        dispatch(setAgentToken(ssoToken))
        dispatch(setOrgId(orgIdFromUrl));
        // GET BOOKING API CALL REQUEST 
        const agencyData =
        {
          code: agencyDetails.adAgencyCode,
          name: agencyDetails.adTravelAgencyName,
          networkId: agencyDetails.adNetworkId,
          address: {
            line1: agencyDetails.adAddressLine1,
            line2: agencyDetails.adAddressLine2,
            city: {
              name: agencyDetails.adCity,
            },
            state: {
              code: agencyDetails.provinceOrState
            },
            country: {
              code: agencyDetails.country
            },
            postalCode: agencyDetails.adPostalCode,
            addressType: "Unspecified" 
          },
          phone: {
            number: agencyDetails.adNetworkId,
            type: "Unknown"
          },
          agencyGroupName: agencyDetails?.consortiumName,
          agencyGroupCode: agencyDetails.consortiumId
        };
    
        const travelAgent = {     
          firstName: agencyDetails.firstName,
          lastName: agencyDetails.lastName,
          userName: agencyDetails.username
        };

        let requestPayload = {
          recordLocator: pnrFromUrl,
          providerId: providerIdFromUrl,
          organizationId: orgIdFromUrl,
          agencyId: agencyDetails.travelBusinessesId,
          agencyGroupId: agencyDetails.consortiumId,
          agency: agencyData,
          travelAgent: travelAgent
        }

        let result = await dispatch(getPnrDetails(requestPayload))
          if (result) {
            // setLoad(true)
            setStatus(result && result.bookingStatusDetail && result.bookingStatusDetail.code)
      
            if (result.bookingDetails && result.bookingDetails.segments) {
               dispatch(setBookingItinenary(result.bookingDetails))
              //  history.push("/booking-confirmation")
            } 
            // setLoad(true)
            setIsUpdate(true)  
            let verifyPnrResult = await callVerifyPNR(result)
            
             
            
            let defaultTransaction;
            if(verifyPnrResult?.status == 'Success'){
              toast.dismiss();
              defaultTransaction = verifyPnrResult?.defaultTransactionDetails;
              if(verifyPnrResult?.defaultTransactionDetailsForNonAcceptedCC?.[0]){
                dispatch(setPaymentRulesForNonAcceptedCC(verifyPnrResult?.defaultTransactionDetailsForNonAcceptedCC?.[0]));
              }
              if(verifyPnrResult?.merchantFeeForNonAcceptedCC?.amount > 0){
                dispatch(setMerchantFeeForNonAcceptedCC(verifyPnrResult?.merchantFeeForNonAcceptedCC?.amount));
              }
              dispatch(setItenaryData(verifyPnrResult?.itineraryFare))
              dispatch(setItinaryFaresType(verifyPnrResult?.itineraryFare?.type))
            } else {
              defaultTransaction = result?.defaultTransactionDetails;
              if(result?.defaultTransactionDetailsForNonAcceptedCC?.[0]){
                dispatch(setPaymentRulesForNonAcceptedCC(result?.defaultTransactionDetailsForNonAcceptedCC?.[0]));
              }
              if(result?.merchantFeeForNonAcceptedCC?.amount > 0){
                dispatch(setMerchantFeeForNonAcceptedCC(result?.merchantFeeForNonAcceptedCC?.amount));
              }

              if(result?.bookingDetails?.itineraryFare){
                dispatch(setItenaryData(result?.bookingDetails?.itineraryFare))
                dispatch(setItinaryFaresType(result?.bookingDetails?.itineraryFare?.type))
              }
            }
            dispatch(setMarkupApplied(true))
            for (let index = 0; index < defaultTransaction?.length; index++) {
              defaultTransaction[index]["agencyMarkups"] = result?.bookingDetails?.agencyMarkups
              defaultTransaction[index]["itineraryFare"] = result?.bookingDetails?.itineraryFare
              if (defaultTransaction[index]?.type == "CreditCard") {
                dispatch(setPaymentRules(defaultTransaction[index]))
                dispatch(setInitialPaymentRules(defaultTransaction[index]))
              }
              else if (defaultTransaction[index]?.type == "Cheque") {
                dispatch(setPaymentRulesForCheque(defaultTransaction[index]))
                dispatch(setInitialPaymentRulesChq(defaultTransaction[index]))
              }
              else {
                dispatch(setPaymentRules(defaultTransaction[index]))
                dispatch(setInitialPaymentRules(defaultTransaction[index]))
              }
            }
            setFetchLatestFare(false)
            // setLoad(true)
          }
        }
        else{
          history.push("/")
        }
    }
  }
// SSO TOKEN FLOW ON CONFIRMATION PAGE END
  const agencyData = {
    code: agencyDetails.adAgencyCode,
    name: agencyDetails.adTravelAgencyName,
    networkId: agencyDetails.adNetworkId,
    address: {
      line1: agencyDetails.adAddressLine1,
      line2: agencyDetails.adAddressLine2,
      city: {
        name: agencyDetails.adCity,
        // code: agencyDetails.adCity
      },
      state: {
        // name: agencyDetails.provinceOrState,
        code: agencyDetails.provinceOrState,
      },
      country: {
        // name: agencyDetails.country,
        code: agencyDetails.country,
      },
      postalCode: agencyDetails.adPostalCode,
      addressType: "Unspecified", //Unspecified,Home,Business,Office,Billing,Residential,Destination
    },
    phone: {
      number: agencyDetails.adNetworkId,
      type: "Unknown", //Unknown,Fax,Home,Business,Agency,Phone,Mobile
    },
    agencyGroupName: agencyDetails?.consortiumName,
    agencyGroupCode: agencyDetails.consortiumId,
  };

  const travelAgent = {
    firstName: isInternalUserAutheticated
      ? agentDetails.firstName
      : agencyDetails.firstName,
    lastName: isInternalUserAutheticated
      ? agentDetails.lastName
      : agencyDetails.lastName,
    userName: isInternalUserAutheticated
      ? agentDetails.username
      : agencyDetails.username,
  };

  let flightsArr = [];
  let seatArr = [];

  if (segment && segment.length > 0) {
    segment.map((obj) => {
      let data = Object.values(obj);

      let flightData = data && data[0] && data[0].flights;
      flightsArr = [...flightsArr, ...flightData];
    });
  }

  const [status, setStatus] = useState("");
  const [isEdit, setEdit] = useState(false);
  const [selectedSeatArr, setSelectedSeat] = useState([]);

  useEffect(() => {
    if (!bookingWithQuote) {
      dispatch(setBookingDetails({}));
    }
  }, [bookingWithQuote]);

  const pnrApiCall = async () => {
   if(ssoToken !== undefined) return 
    let requestPayload = {
      recordLocator: flightDetail && flightDetail.pnr,
      providerId: providerId,
      organizationId: orgId,
      agencyId: agencyId,
      agencyGroupId: agencyGroupId,
      agency: agencyData,
      travelAgent: travelAgent,
    };
    let result = await dispatch(getPnrDetails(requestPayload));
    setLocalRecordLocator(flightDetail.pnr)
    if(result =="error"){
      setLoad(true);
      setTimeoutError(true);
    }

    if (result.error && (!(result?.bookingDetails?.hasOwnProperty('itineraryFare')))) {
      history.push("/HeaderMyFiles");
      setLoad(true);
    } else if (result) {
      if(result?.error?.message){
        setGetBookingErrorMsg(true);
      }
      // setLoad(true);
      setStatus(
        result && result.bookingStatusDetail && result.bookingStatusDetail.code
      );
      if(result?.bookingDetails?.isPaymentDoneManually){setIsPaymentDoneManually(result?.bookingDetails?.isPaymentDoneManually)}
      if(result?.bookingDetails?.isItineraryChanged && result?.bookingStatusDetail?.code === "NP"){
        setIsItineraryModified(result?.bookingDetails?.isItineraryChanged)
      }
      if (result.bookingDetails && result.bookingDetails.segments) {
        dispatch(setBookingItinenary(result.bookingDetails));
      }
      if(result?.bookingDetails?.isPQupdatedManually || !result?.bookingDetails?.itineraryFare){
        result?.bookingDetails?.isPQupdatedManually && setIsPQupdatedManually(true);
        !result?.bookingDetails?.itineraryFare && setIitineraryFareNotPresent(true)
        // setLoad(true)
        toast.error(t("The Price Summary details and Payment"), { position: toast.POSITION.TOP_CENTER, autoClose: true });
      }
      for(let index = 0; index < result?.bookingDetails?.warnings?.length; index++){
        if(result?.bookingDetails?.warnings[index]?.message?.includes(`Passenger Name couldn't be matched with SSR Docs so unable to display Gender & DoB. Please contact us to confirm the details in the PNR`))
        {
          setDobGenderError(false);
          // setLoad(true)
          toast.error(t("Passenger Name couldn't"), { position: toast.POSITION.TOP_CENTER, autoClose: true });
          break;
        }else{
          setDobGenderError(false);
        }
      }
      // setLoad(true)
      setIsUpdate(true)
      let verifyPnrResult = await callVerifyPNR(result)
      
      
      let defaultTransaction;
      if (verifyPnrResult?.status == 'Success') {
        toast.dismiss();
        defaultTransaction = verifyPnrResult?.defaultTransactionDetails;
        dispatch(setItenaryData(verifyPnrResult?.itineraryFare))
        dispatch(setItinaryFaresType(verifyPnrResult?.itineraryFare?.type))
        if (verifyPnrResult?.defaultTransactionDetailsForNonAcceptedCC?.[0]) {
          dispatch(setPaymentRulesForNonAcceptedCC(verifyPnrResult?.defaultTransactionDetailsForNonAcceptedCC?.[0]));
        }
        if (verifyPnrResult?.merchantFeeForNonAcceptedCC?.amount > 0) {
          dispatch(setMerchantFeeForNonAcceptedCC(verifyPnrResult?.merchantFeeForNonAcceptedCC?.amount));
        }
      } else {
        defaultTransaction = result?.defaultTransactionDetails;
        if(result?.bookingDetails?.itineraryFare){
          dispatch(setItenaryData(result?.bookingDetails?.itineraryFare))
          dispatch(setItinaryFaresType(result?.bookingDetails?.itineraryFare?.type))
        }
        if (result?.defaultTransactionDetailsForNonAcceptedCC?.[0]) {
          dispatch(setPaymentRulesForNonAcceptedCC(result?.defaultTransactionDetailsForNonAcceptedCC?.[0]));
        }
        if (result?.merchantFeeForNonAcceptedCC?.amount > 0) {
          dispatch(setMerchantFeeForNonAcceptedCC(result?.merchantFeeForNonAcceptedCC?.amount));
        }
      }
      dispatch(setMarkupApplied(true))
      for (let index = 0; index < defaultTransaction?.length; index++) {
        defaultTransaction[index]["agencyMarkups"] = result?.bookingDetails?.agencyMarkups
        defaultTransaction[index]["itineraryFare"] = result?.bookingDetails?.itineraryFare
        if (defaultTransaction[index]?.type == "CreditCard") {
          dispatch(setPaymentRules(defaultTransaction[index]))
          dispatch(setInitialPaymentRules(defaultTransaction[index]))
        }
        else if (defaultTransaction[index]?.type == "Cheque") {
          dispatch(setPaymentRulesForCheque(defaultTransaction[index]))
          dispatch(setInitialPaymentRulesChq(defaultTransaction[index]))
        }
        else {
          dispatch(setPaymentRules(defaultTransaction[index]))
          dispatch(setInitialPaymentRules(defaultTransaction[index]))
        }
      }
      setFetchLatestFare(false)
      setLoad(true)
    }
  // };

      if (result.bookingDetails && result.bookingDetails.segments) {
        dispatch(setBookingItinenary(result.bookingDetails))
      }    
    }



  const callVerifyPNR = async (result) => {
    let status = result?.bookingStatusDetail?.code;

    let currentDateTime = new Date();
    let currentDateAndTime = moment(currentDateTime).format("YYYY-MM-DD");
    // let bookingDateAndTime = bookingDate && moment(bookingDate).format("YYYY-MM-DD")
    let bookingDateAndTime = result?.bookingDate && moment(result?.bookingDate).format("YYYY-MM-DD")

    if (status == "NP" && (!saveCalculatorFlow) && (result.providerName !== "NDC") && (result.providerName !== "Sabre_NDC") && (result.providerName !== "Amadeus_NDC")) {
      //if (result?.verifiedFareDate ? moment(result?.verifiedFareDate).format("YYYY-MM-DD") != currentDateAndTime : true) {
        setFetchLatestFare(true)
        // toast.info(t("Please wait while we fetch the latest fare."), { position: toast.POSITION.TOP_CENTER, autoClose:true, closeButton: false });

        let result = await dispatch(getRepriceBeforePayment(recordLocator)) 
        if (result == "error") {
          toast.error(t("143"), {
            position: toast.POSITION.TOP_CENTER,
            autoClose: true,
          });
          history.push("/HeaderMyFiles");
        } else if (result.status == "Success") {
          if (result?.fareChange?.status && (taxIncreasedStatusArray.includes(result?.fareChange?.status))) {
            toast.dismiss();
            setVerifyPnrPopUp(true) 
            setFetchLatestFare(false)
            setLoad(true)
            return result;
          }
        } else if (result.status == "Failed") {
          setFetchLatestFare(false)
          setLoad(true)
          // setIsVerifyPNRFailed(true)
          return result;
        }
      //}
    }
    setFetchLatestFare(false)
    setLoad(true)
    return undefined
  }
  

  useEffect(() => {
    pnrApiCall();
    dispatch(setSeat([]));
    dispatch(setPrevSeat([]));
    dispatch(setEditSeat([]));
    dispatch(setSeatMapData([]));
    dispatch(setSaveSeat([]));
    
  }, []);

  


  // let editDataArray = editSeatRecord
  // let addDataArray = []
  // let testData = seat && seat.filter(objNew => editSeatRecord.find(ppData => ppData && ppData.flightNumber === objNew.flightNumber))

  // seat && seat.map(data => {
  //   if (data.isEdit === true) {
  //     editDataArray.push(data)
  //   } else {
  //     addDataArray.push(data)
  //   }

  // })

    //  let editDataArray = []


//This values are used in side the editSeatData Function

  // const isSameUser = (a, b) => a.passengerId == b.passengerId;

  // const onlyInLeft = (left, right, compareFunction) =>
  //   left.filter(leftValue =>
  //     !right.some(rightValue =>
  //       compareFunction(leftValue, rightValue)));

// This Function is never used

  // const editSeatData = () => {

  //   let editDataArrayFinal = [...editDataArray]
  //   editDataArray && editDataArray.map(data => {

    
  //     let count = passengerData && passengerData.length

  //     let filterSeatEditData = editDataArray && editDataArray.filter(editVal => editVal.flightNumber == data.flightNumber)
     
  //     let filterSeatData = seat && seat.filter(editVal => editVal.flightNumber == data.flightNumber)
  //     if (filterSeatEditData.length < count) {

  //       // Get items that only occur in the left array,
  //       // using the compareFunction to determine equality.

  //       const onlyInA = onlyInLeft(filterSeatData, filterSeatEditData, isSameUser);
  //       // const onlyInB = onlyInLeft(onlyInA, filterSeatAddData, isSameUser);
  //       editDataArrayFinal.push(...onlyInA)

  //     }

  //   })

  //   return editDataArrayFinal

  // }

  useEffect(() => {
    let flag = false;
    if (passengerData && bookingItinenaries.segments) {

      // let itinen = bookingItinenaries.segments;
      // let PassportMandatory = isPassportMandatory
      passengerData.map((obj, i) => {
        if (isPassportMandatory) {
          if (obj.passports.length == 0) {
            flag = true;
          }
        }
      });
      dispatch(setIsPassportMandatory(flag))
    }
  }, [bookingItinenaries, passengerData,isPassportMandatory])

  useEffect(() => {
    if (passengerData && passengerData.length > 0) {
      passengerData.map((passengerObj) => {
        passengerObj.addOns &&
          passengerObj.addOns.map((obj) => {
            if (obj.seat && Object.keys(obj.seat).length > 0) {
              let newObj = {
                flightNumber: obj.flightNumber,
                seat: obj?.seat?.seatNumber,
                amount: obj?.seat?.totalAmount?.amount,
                currency: obj?.seat?.totalAmount?.currency,
                isEdit: false,
                aLaCarteOfferItemID: obj?.seat?.aLaCarteOfferItemID,
              };
              if (passengerObj.id) {
                newObj.passengerId = passengerObj.id;
              }

              seatArr = [...seatArr, newObj];
            }
          });
      });
      let validInfo = false;
      let validationFlagArr = []
      if (!dobGenderError) {
        passengerData.map((obj, i) => {
          let flag=false;
          if (!(!!obj.gender)) {
            flag = true;
          }
          if (!(!!obj.dateOfBirth)) {
            flag = true;
          }

          let dobFlag = dobAgeCheckValidation(tripTypeFlowFrom, allData, tripData, obj.dateOfBirth, obj.paxType)
          if(dobFlag){
            flag=dobFlag
          }

          if (i == 0 && obj?.contact?.phones?.length == 0) {
            flag = true
          }
          if (i == 0 && obj?.contact?.emails?.length == 0) {
            if (obj?.contact?.phones[0]?.type != "Mobile") {
              flag = true
            }
          }
          console.log("passengerValidation1",i,flag,dobFlag)
          validationFlagArr.push(flag)
        });
      }
      if (validationFlagArr.includes(true)) {
        validInfo = true
      }
      setNonGigiPNRCheck(validInfo)
      if(allData?.providerName == "Sabre"){
        setValidInfo(validInfo)
      }
    }

    if (seatArr.length > 0) {
      setEditSeatStatus(true);
    }
    setSelectedSeat(seatArr);
    dispatch(setSeat(seatArr));
    dispatch(setPrevSeat(seatArr));
  }, [passengerData]);

  const setLoads = (status) => {
    if (status === true) {
      pnrApiCall();
    } else {
      setLoad(false);
    }
  };

  const setEditStatus = (status) => {
    setEdit(status);
  };

  const updateSeat = async (seatData) => {
    // Prefer the seat[] supplied by the caller (the seat-map integration reads
    // it from the live Redux store right after dispatching setSeat). Fall back
    // to the live store value so the closure-captured `seat` (which can be
    // stale when updateSeat is called in the same event tick that dispatched
    // setSeat — e.g. SeatMap.handleCompleteSelection fires onPassengersUpdate
    // + onClose back-to-back) is never used.
    const seat =
      Array.isArray(seatData) && seatData.length > 0
        ? seatData
        : store.getState().itinenaries.seat;

    if (!hasSeatSelectionChanges(passengerData, seat)) {
      return;
    }

    setAddedSeatList(seat);
    const newData = JSON.parse(JSON.stringify(seat));
    dispatch(setPrevSeat(newData));

    const { addOperations: addData, updateOperations: editData } =
      buildSeatPnrOperationsFromDelta(passengerData, seat, flightsArr);

    if (addData.length > 0) {
      setAddPassenger(addData);
    }
    if (editData.length > 0) {
      setEditPassenger(editData);
    }

    const obj = {};
    if (addData.length > 0) {
      obj.addOperations = addData;
    }
    if (editData.length > 0) {
      obj.updateOperations = editData;
    }

    let updatePassengerArr = [];

    let allPassengerArr = [...editData, ...addData];

    passengerData.map((obj) => {
      let newObj = {
        id: obj.id,
        paxType: obj.paxType,
        firstName: obj.firstName,
        lastName: obj.lastName,
        middleName: obj.middleName,
        prefix: obj.prefix,
      };
      let index = allPassengerArr.findIndex(
        (passenegrObj) => passenegrObj.passengerId == obj.id
      );
      if (index >= 0) {
        updatePassengerArr.push(newObj);
      }
    });

    if (updatePassengerArr.length === 0) return;

    const travelAgent = {
      firstName: isInternalUserAutheticated
        ? agentDetails.firstName
        : agencyDetails.firstName,
      lastName: isInternalUserAutheticated
        ? agentDetails.lastName
        : agencyDetails.lastName,
      userName: isInternalUserAutheticated
        ? agentDetails.username
        : agencyDetails.username,
    };

    let payload = {
      travelAgent: travelAgent,
      providerId: providerId,
      organizationId: orgId,
      agencyId: agencyId,
      agencyGroupId: agencyGroupId,
      recordLocator: flightDetail.pnr,
      passengers: updatePassengerArr,
      pnrOperations: obj,
    };

    setIsUpdate(false);
    let result = await dispatch(updatePnr(payload));

    // seat status from update pnr
    if (result && result.pnrOperations) {
      setUpdateOperations1(result.pnrOperations);
      dispatch(setEditSeatRecord([]));
    }

    let str = " ";
    if (result) {
      pnrApiCall();
    }
    if (
      result.pnrOperations &&
      Object.keys(result.pnrOperations).length === 0
    ) {
      // return toast.error(`Edit passenger data is failed to update`, { position: toast.POSITION.TOP_CENTER, autoClose: true });
    }
    if (result && result.pnrOperations) {
      let isupdatefailed = false;
      str = str + t(`Failed to Update`) + ` `;
      let username = "";
      if (
        result.pnrOperations.updateOperations &&
        result.pnrOperations.updateOperations.length > 0
      ) {
        let updateData = result.pnrOperations.updateOperations;
        for (let i = 0; i < updateData.length; i++) {
          let matchedObj =
            result &&
            result.passengers.find((obj) => {
              return obj[`id`] === updateData[i].passengerId;
            });
          let username = matchedObj.firstName + ` ` + matchedObj.lastName;
          if (
            updateData[i].addOnsUpdates &&
            updateData[i].addOnsUpdates.length > 0
          ) {
            for (let k = 0; k < updateData[i].addOnsUpdates.length; k++) {
              if (
                updateData[i].addOnsUpdates[k].failedUpdates &&
                updateData[i].addOnsUpdates[k].failedUpdates.length > 0
              ) {
                str =
                  str +
                  updateData[i].addOnsUpdates[k].failedUpdates.join() +
                  ` ` +
                  `  having flightNo ${updateData[i].addOnsUpdates[k].flightNumber} ,`;
                isupdatefailed = true;
              }
            }
          }
          str = str + `of ${username}`;
        }
      }
      if (
        result.pnrOperations.addOperations &&
        result.pnrOperations.addOperations.length > 0
      ) {
        let addData = result.pnrOperations.addOperations;
        for (let i = 0; i < addData.length; i++) {
          let matchedObj =
            result &&
            result.passengers.find((obj) => {
              return obj[`id`] === addData[i].passengerId;
            });
          let username = "";
          if (matchedObj) {
            username = matchedObj.firstName + ` ` + matchedObj.lastName;
          }

          if (addData[i].addOnsUpdates && addData[i].addOnsUpdates.length > 0) {
            for (let k = 0; k < addData[i].addOnsUpdates.length; k++) {
              if (
                addData[i].addOnsUpdates[k].failedUpdates &&
                addData[i].addOnsUpdates[k].failedUpdates.length > 0
              ) {
                str =
                  str +
                  addData[i].addOnsUpdates[k].failedUpdates.join() +
                  ` ` +
                  ` having flightNo ${addData[i].addOnsUpdates[k].flightNumber} ,`;
                isupdatefailed = true;
              }
            }
          }
          str = str + `of ${username}`;
        }
      }

      if (
        result.pnrOperations.deleteOperations &&
        result.pnrOperations.deleteOperations.length > 0
      ) {
        let addData = result.pnrOperations.deleteOperations;
        for (let i = 0; i < addData.length; i++) {
          let matchedObj =
            result &&
            result.passengers.find((obj) => {
              return obj[`id`] === addData[i].passengerId;
            });

          if (matchedObj) {
            let name = matchedObj.firstName + ` ` + matchedObj.lastName;
            username = name === username ? "" : name;
          }

          if (addData[i].failedUpdates && addData[i].failedUpdates.length > 0) {
            str = str + addData[i].failedUpdates.join() + `  ,`;

            isupdatefailed = true;
          }
          if (addData[i].addOnsUpdates && addData[i].addOnsUpdates.length > 0) {
            for (let k = 0; k < addData[i].addOnsUpdates.length; k++) {
              if (
                addData[i].addOnsUpdates[k].failedUpdates &&
                addData[i].addOnsUpdates[k].failedUpdates.length > 0
              ) {
                str =
                  str +
                  addData[i].addOnsUpdates[k].failedUpdates.join() +
                  ` ` +
                  ` having flightNo ${addData[i].addOnsUpdates[k].flightNumber} ,`;
                isupdatefailed = true;
              }
            }
          }
          if (username.trim().length > 0) {
            str = str + `of ${username}`;
          }
        }
      }

      if (isupdatefailed) {
        // toast.error(`${str}`, { position: toast.POSITION.TOP_CENTER, autoClose: true });
      } else {
        // toast.success(`Passenger seats updated successfully`, { position: toast.POSITION.TOP_CENTER, autoClose: true });
      }
    }
  };

  const clearData = () => {
    setEditPassenger([]);
    setAddPassenger([]);
  };

  let showIternary = false;

  if (
    bookingItinenaries.hasOwnProperty("segments") &&
    bookingItinenaries.segments.length !== 0
  ) {
    showIternary = true;
  } else if (bookingItinenaries.length !== 0) {
    showIternary = true;
  }

  useEffect(() => {

    if (passengerData && passengerData.length > 0 && isUpdate) {
      // getPaymentRulesApi()
    }

  }, [isUpdate])


  const getPaymentRulesApi = async () => {
    
    let agencyArr = []
    if (adultsCount > 0) {
      let obj = {
        paxType: PassengerType.ADULT,
        quantity: adultsCount,
        perPaxAmount: {
          amount: adultAmount ? adultAmount : 0,
          currency: currency
        }
      }
      agencyArr.push(obj)
    }
    if (childCount > 0) {
      let obj = {
        paxType: PassengerType.CHILD,
        quantity: childCount,
        perPaxAmount: {
          amount: childAmount ? childAmount : 0,
          currency: currency
        }
      }
      agencyArr.push(obj)
    }

    if (infantCount > 0) {
      let obj = {
        paxType: PassengerType.INFANTINLAP,
        quantity: infantCount,
        perPaxAmount: {
          amount: infantAmount ? infantAmount : 0,
          currency: currency
        }
      }
      agencyArr.push(obj)
    }

    let arr = [];
    let passengerRef = [];
    for (let i = 1; i <= passengerData.length; i++) {
      if (i <= adultsCount) {
        arr = [
          ...arr,
          {
            id: `${i}`,
            paxType: PassengerType.ADULT,
          },
        ];
        passengerRef.push(`${i}`);
      } else if (i > adultsCount && i <= adultsCount + childCount) {
        let j = i - adultsCount;
        arr = [
          ...arr,
          {
            id: `${i}`,
            paxType: PassengerType.CHILD,
          },
        ];
        passengerRef.push(`${i}`);
      } else {
        let j = i - (adultsCount + childCount);
        arr = [
          ...arr,
          {
            id: `${i}`,
            paxType: PassengerType.INFANTINLAP,
          },
        ];
        passengerRef.push(`${i}`);
      }
    }

    let reqPayload = {
      recordLocator: recordLocator,
      fareType: fareTypeFromPnr,
      passengers: arr,
      agencyMarkups: agencyArr,
      payments: [
        {
          passengerRefs: passengerRef,
          type: "CreditCard",
        },
      ],
    };
    let result = dispatch(getPaymentRules(reqPayload, "CreditCard"));
    if (result) {
      reqPayload = {
        recordLocator: recordLocator,
        fareType: fareTypeFromPnr,
        passengers: arr,
        agencyMarkups: agencyArr,
        payments: [
          {
            passengerRefs: passengerRef,
            type: "Cheque",
          },
        ],
      };

      dispatch(getPaymentRules(reqPayload, "Cheque"));
    }
  };
  let fareType =
    bookingDetail && bookingDetail.fareType;

    const setValidInfoFunc=(val)=>{
      setValidInfo(val);
    }

    const setSaveDetailsFunc=(val)=>{
      let value=counter;
        setCounter(value+1);
        setSaveDetails(val);      
    }

    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
      if (paymentErrorMsg) {
        setPaymentErrorBanner(paymentErrorMsg);
        dispatch(setPaymentErrorMsg(""));
      }
    }, [paymentErrorMsg, dispatch]);

  return (
    <>
      <Header setClass="container-fluid" show="d-none" />
      {isload ? <BookingProvider>
        <BookingFor />
        {timeOutError ?
          <div className="booking-main container bd-main-container">
            <div className="seat-udate-status">
              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
              <strong>Technical error has occurred. Unable to fetch booking details.</strong>
            </div>
          </div>

        :
        <>
            
        <div className="booking-main">
              
          <div className="container bd-main-container">
                {pnrBookingDetails &&
                  pnrBookingDetails.cancellationStatus !== "Cancelled" &&
                  pnrBookingDetails.bookingStatusDetail &&
                  pnrBookingDetails.bookingStatusDetail.code !== "CR" &&
                  pnrBookingDetails.bookingStatusDetail.code !== "NTC" &&
                  pnrBookingDetails.bookingStatusDetail.code !== "TC" &&
                   cancellationFlag &&
                    pnrBookingDetails?.onlineCancellationStatus === "NotAllowed" &&

                    <>
                    {showTicketProcessingNote ? (
                  <div className=" quotenotehold"><div className="col-lg-12 quotenotedivhold"><div><span><i className="fa fa-exclamation-circle" aria-hidden="true"></i></span> </div><div>
                    <p className="quotepara">{t("We systems require up to 15 minutes to process newly issued tickets. Please wait at least 15 minutes after ticket issuance before cancelling your booking.")}
                    </p></div></div></div>
                    ) : (
                    <div className=" quotenotehold"><div className="col-lg-12 quotenotedivhold"><div><span><i className="fa fa-exclamation-circle" aria-hidden="true"></i></span> </div><div>
                      <p className="quotepara">{t("We Are Sorry But Online Cancellation For This File")} {recordLocator} {t("Is Not Allowed. Please Contact Us.")}
                      </p></div></div></div>
                    )}
                    </>
                  }
            <div className="row  bd-main-row">
                <div className="col-lg-12">
                  <ConfirmationHead bookingDate={bookingDate} from="confirmation" isInternalUserAutheticated={isInternalUserAutheticated} setLoads={(flag)=>setLoads(flag)} setLoad={(value)=>setLoad(value)}/>
                </div>
            </div>

            <div className="row  bd-main-row">

              <div className="col-lg-8 bd-main-col">
               
                {flightDetail && flightDetail.bookingStatus && (flightDetail.bookingStatus.code === "NP" || flightDetail.bookingStatus.code === "SC") && optionDateToDisplay &&
                
                    <BookingQuoteNote bookingDate={bookingDate} />
                    
                 
                }

                {
                  (!bookingData.segments || (bookingData.segments && bookingData.segments.length === 0))
                  ?
                 
                    <div className="bd-itinerary-sec bd-confirmation-sec">
                      <div className="quotenote mb-3">
                        <div className="col-lg-12 quotenotediv reprice">
                          <div>
                            <span>
                              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                            </span>{" "}
                          </div>
                          <div>
                            <p>
                               {t('1006')}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                  :
                    // (!bookingData.itineraryFare || (bookingData.itineraryFare && bookingData.itineraryFare.length === 0)) ?
                    // <div className="bd-itinerary-sec bd-confirmation-sec">
                    //     <div className="quotenote mb-3">
                    //       <div className="col-lg-12 quotenotediv reprice">
                    //         <div>
                    //           <span>
                    //             <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                    //           </span>{" "}
                    //         </div>
                    //         <div>
                    //           <p>
                    //             {t("A technical issue occurred, please contact us")}
                    //           </p>
                    //         </div>
                    //       </div>
                    //     </div>
                    //   </div>
                    // :
                  <>
                       
                       {((bookingStatus && bookingStatus.code === "NP") ||
                            (bookingStatus && bookingStatus.code === "BA") ) && !ticketableDateCheck && optionDateToDisplay &&
                          
                          <div className="seat-udate-status">
                                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                <strong>{t('1007')}</strong>                
                          </div>
                          
                        }

                          {getBookingErrorMsg && (bookingStatus && bookingStatus.code === "NP") && ticketableDateCheck &&
                            <div className="seat-udate-status">
                              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                              <strong>{t('We are sorry, payment cannot be applied to this booking due to a technical issue. Please contact us for assistance.')}
                              </strong>
                            </div>
                          }
                          {getBookingErrorMsg &&
                            <div className="seat-udate-status">
                              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                              <strong>{t(`We encountered an issue while retrieving the latest PNR details. As a result, we’re displaying information retrieved from 'My Files' instead. Please note that this data may not reflect the most recent updates.`)}
                              </strong>
                            </div>
                          }
                        { validInfo &&
                          <div>
                            <div className="seat-udate-status">
                              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                              <strong>{t("Please Fill All The Mandatory Fields.")}</strong>
                            </div>
                          </div>
                        }

                        { isItineraryModified &&
                          <div>
                            <div className="seat-udate-status">
                              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                              <strong>{t("We are sorry, payment cannot be applied to this booking due to a technical issue. Please contact us for assistance.")}</strong>
                            </div>
                          </div>
                        }

                          {(bookingStatus?.code != "PNTC" && bookingStatus?.code != "TC" && bookingStatus?.code != "NTC" && bookingStatus?.code != "CR") && (pnrBookingDetails.cancellationStatus == "Unknown" || pnrBookingDetails?.onlineCancellationStatus == "Unknown") &&
                          <div>
                            <div className="seat-udate-status">
                              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                              <strong>{t("This file cannot be cancelled through GiGi, please contact us.")}</strong>
                            </div>
                          </div>
                        }

                          {paymentErrorBanner ? (
                            <div className="seat-udate-status mb-3">
                              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                              <strong>{paymentErrorBanner}</strong>
                            </div>
                          ) : null}

                      <div className="bd-itinerary-sec bd-confirmation-sec">
                        {showIternary &&
                          <BookingItinenaryMulticity itinenary={bookingItinenaries} recordLocator={recordLocator} from="confirmation" />
                        }
                        {/* {(tripTypeValue === TripType.ONEWAY) && showIternary &&
                          <BookingItineraryOneway itinenary={bookingItinenaries} recordLocator={recordLocator} from="confirmation" />
                        }
                        {(tripTypeValue === TripType.ROUNDTRIP || tripTypeValue === TripType.OPENJAW && showIternary) &&
                          <BookingItineryDetails itinenary={bookingItinenaries.segments} recordLocator={recordLocator} from="confirmation" />
                        } */}
                        {/* <BookingTravelAgent /> */}
                      </div>
                    
                      <BookingPassengerDetails
                        updateOperations={updateOperations1}
                        isUpdate={isUpdate}
                        selectedSeatArr={selectedSeatArr}
                        setEditStatus={(status) => setEditStatus(status)}
                        updateSeat={(seat) => updateSeat(seat)}
                        clearData={clearData} 
                        validInfo={validInfo}
                        setValidInfoFunc = {(val)=>setValidInfoFunc(val)}
                        nonGigiPNRCheck = {nonGigiPNRCheck}
                        saveDetails = {saveDetails}
                        setSaveDetailsFunc = {(val)=>setSaveDetailsFunc(val)}
                        dobGenderError={dobGenderError}
                        counter={counter}
                        />
                    
                      {(fareType === "Land Net"  || fareType === "Cruise Net") &&
                        <div><BookingNumberForLandCruise fareType={fareType} from="confirmation"/></div>
                      }
                      <BookingTravelAgentInfo from="confirmation"/>
                      <div >{!fetchLatestFare && !window.isGoldenticket() && <Markup from="confirmation" show={(bookingStatus && (bookingStatus?.code == "NP" || bookingStatus.code === "SC") && paymentTypeDetails && paymentTypeDetails.length === 0)?true:false}/>}</div>
                     
                      <div className="row">
                        {/* <div className="col-12"> */}
                          {<BookingConfirmationButton isLoad={(status) => setLoads(status)} prevState={prevState} validInfo={validInfo} setSaveDetailsFunc={(val) => setSaveDetailsFunc(val)} isEdit={isEdit} isPaymentDoneManually={isPaymentDoneManually} isPQupdatedManually={isPQupdatedManually} verifyPnr={fetchLatestFare} itineraryFareNotPresent={itineraryFareNotPresent} isItineraryChanged={isItineraryModified} getBookingErrorMsg={getBookingErrorMsg} />}
                        {/* </div> */}
                      </div>
                  </>
                }
              </div>
              <div className="col-lg-4 bd-main-col">
                  <div className="bd-priceSummary-sticky">
                      {(paymentTypeDetails && paymentTypeDetails.length === 0) ?

                        <>
                          {(!isPQupdatedManually && !isItineraryModified && !itineraryFareNotPresent) ?
                            
                            <div className="bd-leftSection-scroll">
                              {configuration?.showCombineFareBreakdown ?
                                <div className="pricesummary">
                                  <div className="priceinner row">
                                    <div className="col-md-12 bd-main-col pricecol">
                                      <DuffelPriceSummary fromBookingConfirmation={true} />
                                    </div>
                                  </div>
                                </div>
                                :

                                <BookingConfirmationPrice statusCode={bookingStatus?.code} payableBreakDownFlag={true} />
                              }
                            </div>
                            :null
                            }
                        </>
                        :
                        priceValue &&
                        <>
                          {(!isPQupdatedManually && !isItineraryModified && !itineraryFareNotPresent) ? 
                          <>
                            {configuration?.showCombineFareBreakdown ?
                            <div className="pricesummary">
                              <div className="priceinner row">
                                <div className="col-md-12 bd-main-col pricecol">
                                  <DuffelPriceSummary fromBookingConfirmation={true} />
                                </div>
                              </div>
                            </div>
                            :
                            <BookingConfirmationPrice statusCode={bookingStatus?.code} payableBreakDownFlag={false} />}
                            </>
                            :
                            null

                            }

                          {!isPaymentDoneManually && !isItineraryModified && <BookingPaymentSummary passengerData={passengerData} paxFares={paxFares} paymentTypeDetails={(!isDuffleFlow && expandedPaymentDetails) ? expandedPaymentDetails : paymentTypeDetails} />}
                        </>

                      }
                  </div>
                
              </div>
            </div>

            {/* {(!bookingData.itineraryFare || (bookingData.itineraryFare && bookingData.itineraryFare.length === 0)) ||
                  (!bookingData.segments || (bookingData.segments && bookingData.segments.length === 0)) ?
              ""
            : */}
            
            {/* } */}
          </div>
        </div></>}



      </BookingProvider> :
        <div className="col-md-12 text-center mt-3" style={{height:"50vh"}}>
          <SpinnerLoader />
          <div className='new-loader-text'>
          {fetchLatestFare ?
            t("GiGi is verifying the taxes and updating the values in your price summmary.")
            :
            t("Please wait while GiGi is retrieving your booking data.")
          }
          </div>
        </div>}
        
        <Dialog
             fullWidth
             maxWidth="sm"
             open={verifyPnrPopUp}
             keepMounted
             aria-labelledby="alert-dialog-slide-title"
             aria-describedby="alert-dialog-slide-description"
             className="fareType-dialog"
         >
        <div className={"recheck-popup"}>
          <div className="recheck-popup-box">
            <span className="rp-close" onClick={() => setVerifyPnrPopUp(false)}>
              &times;
            </span>
            <div style={{"marginBottom":"2rem"}}>
            {t("Please Note that the taxes were recalculated")}
            </div>
            
            <div className="btn-fareChange">
                <button className="btn btn-primary" onClick={() => setVerifyPnrPopUp(false)}>{t("OK")}</button>
            </div>
          </div>
        </div>
        </Dialog>


    </>
 
  );
}
export default BookingConfirmationContainer;



